import config from "../config";
import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};


// Get Bot list .
export const get_BotList = data => api.get(url.botList, data);

//Get Group list 
export const get_BotListGroup = data => api.get(url.groupList,data);

//Get Group Details.
export const get_group_details = data => api.get(url.groupDetails,data);

// Get Bot Details
export const get_BotDetails = data => api.get(url.botDetails,data)

export const get_tool_list = data => api.get(url.get_tool_list,data)

// Update tool status.
export const toggle_tool_status = data => api.create(url.update_tool_status,data)

//Update bot Derails .
export const updateBotDetails = data => api.create(url.update_Bot_Configurations,data)

//Update bot Derails with logo.
export const updateBotDetails_logo = data => api.upload_file_put(url.update_Bot_Configurations_logo+`/${data.get("bot_id")}`,data)

//Update bot logo.
export const updateBot_logo = data => api.upload_file(url.update_bot_image,data)

// update Bot title .
export const update_Bot_title = data => api.create(url.update_Bot_title,data)


// Get Bot Categories
export const get_Bot_Categories = data => api.get(url.bot_Catgory,{all:false})

export const get_distinct_bot_category = data => api.get(url.all_categories_distinct,{all:true})


//Get Model Details
export const get_Models = data => api.get(url.models)


//Get EMBEDDINGz Model Details
export const get_Embedding_Models = data => api.get(url.embedding_models)


//Get threads list
export const get_Threads = data => api.get(url.bot_Threads,data)

//Get workflow Node list
export const node_list = data => api.get(url.workflow_node)

//Get workflow Node list
export const workflow_list = data => api.get(url.workflow_list,data)

//Get workflow category list
export const workflow_category_list = data => api.get(url.get_workflow_category_list,data)


//Get workflow category list
export const remove_workflow = data => api.delete(url.delete_workflow+`/${data.workflow_id}`)


export const dashboard_list = data => api.get(url.dashboard_list, data)

export const dashboard_board_update = data => api.patch(url.update_dashboard_details+`/${data.get("dashboard_id")}`,data)

export const get_group_bot_list = data => api.get(url.dasboard_bot_list, data)


export const  fetch_fav_prompt_by_group_id = data => api.get(url.fav_prompt_list_by_group, data)

export const fetch_chart_options = data => api.get(url.get_chart_options,data)

export const delete_dashboard =data => api.delete(url.delete_dashboard+`/${data}`, data)


//Get workflow Node list
export const dashboard_create= data => api.upload_file(url.create_dashboard,data)

// Get Dashboard element data . 
export const dashboard_element = data => api.create(url.fetch_dashboard_element_data,data)

// Save dashboard .
export const save_dashboard = data => api.create(url.save_dashboard_elements, data)

// Get Dashboard elements .
export const get_dashboard_elements = data => api.get(url.get_dashboard_data, data)

// get Dashboard Category 

export const fetch_dashboard_category = data => api.get(url.get_dashboard_category, data)


//Get workflow Node list
export const build_work_flow = data => api.create(url.create_workflow,data)

//Get workflow Node list
export const create_work_flow = data => api.upload_file(url.workflow_list,data)

// Edit thread title .
export const edit_Thread_title = data => api.put(url.edit_thread_title+`/${data.thread_id}`,data)



// Delete Thread
export const delete_Thread = data => api.delete(url.thread_delete+`/${data}`)

// Delete THread in Bulk.
export const delete_thread_bulk = data =>  api.create(url.delete_thread_bulk, data)


// Delete Chat Box.
export const delete_chat_bot = data => api.delete(url.delete_Bot+`/${data}`)


// get Thread Messages
export const get_Thread_Messages = data => api.get(url.chat_history+`/${data}`,{limit:config.general_config.chat_limit})
export const delete_Thread_Messages = data => api.delete(url.delete_chat_message,{data})
export const get_Thread_Messages_mongo = data => api.get(url.chat_history_mongo,data)

export const get_Thread_Messages_previous = data => api.get(url.chat_history+`/${data.thread_id}`,data)

// Ask bot 
export const ask_bot_Question = data => api.create(url.ask_bot, data)


// Ask bot  with database
export const ask_bot_Question_database = data => api.create(url.ask_bot_database, data)


//Get Bot favourite Prompt.
export const fav_prompt_list = data => api.get(url.fav_prompt_list,data)

// Run Fav Prompt SQL.
export const run_fav_prompt_sql = data => api.create(url.get_sql_data,data)

// Search Username and Password
export const search_username = data => api.get(url.get_all_users,data)


// Get Bot Favorite Prompt Category .
export const fav_prompt_category = data => api.get(url.fav_prompt_category,data)


// Fetch Token Month Wise .
export const getTokenUsedMonthwise = data => api.get(url.getTokenUsedMonthwise,data)


// Get Bot User.
export const get_bot_users = data => api.get(url.get_bot_user+`/${data.bot_id}`)

// Cancel Bot Reposne .
export const cancel_bot_repos = data => api.create(url.cancel_response_stream,data)


// Create Bot Combine .
export const create_bot_Combine = data => api.create(url.create_combine_bot,data)
// Create Bot Combine with logo .
export const create_bot_Combine_logo = data => api.upload_file(url.create_combine_bot_logo,data)

// Generate Fav Bot Question .
export const generate_fav_question = data => api.create(url.fav_prompt_question_Generation,data)



// Update Combine Bot .
export const update_combine_bot = data => api.upload_file(url.update_combine_bot,data)


// Get Website links.
export const fetch_website_links = data => api.get(url.Fetch_Website_Links,data)


// Get Web site map links.
export const fetch_website_map = data => api.get(url.Fetch_Web_site_map,data)


// Save Fav Prompt .
export const save_fav_prompt = data => api.create(url.save_fav_prompt,data)


// Add new DB Connection.
export const add_new_db_connection = data => api.create(url.add_new_db_connection,data)

// Get Sample Database Connection . 
export const get_sample_db_connection = data => api.get(url.get_sample_db_list,data)

// Insert Sample Database Connection
export const insert_sample_database_into_dbconnection = data => api.create(url.Insert_sample_Db,data)


// Edit Db connection . 
export const edit_db_connection = data => api.put(url.edit_db_connection,data)


// Add new DB Connection.
export const add_new_db_connection_logo= data => api.create(url.add_new_db_connection,data)


//Get the DB Connection
export const get_DB_connections = data => api.get(url.get_DB_connections,data)

// mongo executor .
export const mongo_executor = data => api.create(url.mongo_query_executor,data)

// Create bot with Database structure  .
export const create_db_bot = data => api.create(url.create_db_bot,data)

// Create bot with Database structure  .
export const create_db_bot_logo = data => api.upload_file(url.create_db_bot_logo,data)

//Delete Favorite Prompt .
export const delete_favorite_prompt = data => api.delete(url.delete_fav_prompt+`/${data}`)
//Delete Favorite Prompt .
export const delete_favorite_prompt_cat = data => api.delete(url.delete_fav_prompt_category+`/${data}`)


// Update Favorite Prompt .
export const update_favorite_prompt = data => api.put(url.update_favorite_prompt,data)



// Get table list by id  .
export const get_table_list_list_by_id = data => api.create(url.get_table_list,data)

export const fetch_selected_total_count = data => api.get(url.fetch_table_count,data)




// Get all user .
export const get_all_users = data => api.get(url.get_all_users,data)


// get Group user by bot id .
export const get_group_user_bot_id = data => api.get(url.get_group_user_by_bot_id,data)

// Get Group USer Details .
export const get_group_user_details = data => api.get(url.group_user_details, data)

// Get Group USer Details .
export const get_group_user_logs = data => api.get(url.group_user_logs+`/${data.Group_Id}`, data)

//Add User to Bot.
export const add_user_to_bot = data => api.create(url.add_user_to_bot,data)

// Delete Bot user .
export const delete_bot_user_by_id =  data => api.delete(url.delete_bot_user+`/${data}`)

//Create Group.
export const create_new_group = data => api.create(url.create_new_group,data)


// Update Group Info .
export const update_group_info = data => api.put(url.update_group_info+`/${data.group_id}`,data)

// Update Group Token Allowed in bulk . 
export const update_group_token_allocation_in_bulk = data => api.create(url.update_group_Token_Allocation, data)

// Get plan Summary .
export const fetch_plan_summary = data => api.get(url.plans_summary)
//Get payment method .
export const fetch_payment_method = data => api.get(url.payment_methods)

// Get Billing information
export const billing_info = data => api.get(url.get_billings,data)

// purchase Add_omn .
export const purchase_add_on = data => api.get(url.purchase_addon,data)

// Get current plan add on .
export const get_current_plan_add_on_detaitls = data => api.get(url.get_current_plan_add_on)


export const insert_into_table = data => api.create(url.insert_into_db_table,data)


// update DB bot .

export const update_db_bot = data => api.create(url.update_DB_bot,data)

export const leave_group_by_id = data => api.delete(url.leave_group_group_id+`/${data}`)





// Register Method
export const postRegister = data => api.create(url.POST_REGISTER, { User_Name: data.username , email: data.email, password: data.password , phone:data.phone , recaptcha_response:data.recaptcha_response});

// Login Method
export const postLogin = data => api.create(url.POST_LOGIN, data);


// Forget Password verify Email .
export const reset_password_email_verification = data => api.create(url.reset_email_password,data)
export const reset_password_email_sent = data => api.create(url.reset_email_send,data)

// Update Password .
export const update_password_data = data => api.patch(url.update_password,data)

// Update user image .
export const update_user_image = data => api.upload_file(url.update_user_image,data);

// update user deatils .
export const update_user_details = data => api.patch(url.update_user_details,data);

// Get user details .
export const get_user_details = data => api.get(url.get_user_details);



// postForgetPwd
export const postFakeForgetPwd = data => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = data => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);


export const create_new_thread = data => api.create(url.new_thread,data)
export const clear_context = data => api.create(url.clear_context,data)

// Update Group User .
export const update_group_user = data => api.create(url.update_group_user,data)

//Token Usages per Group .
export const get_group_token = data => api.get(url.groupToken,data);
//Get Group list 
export const delete_group_by_group_id = data => api.delete(url.delete_group,{data});

// Get Plan feature details .
export const fetch_plan_details = data => api.get(url.planFeature)


//Send file to chat .
export const ask_bot_with_file = data => api.upload_file(url.ask_bot_with_file,data)

// Transcription information.
export const get_transcription = data => api.upload_file(url.speech_to_text,data)


// Thumb_UP Message.
export const thumb_up_message = data => api.patch(url.thumb_up_message,data)

//Send file to chat .
export const ask_bot_with_file_and_database = data => api.upload_file(url.ask_bot_with_file_database,data)

// Share point .
export const save_validate_share_points_creds = data => api.create(url.share_point_creds,data)


// Share point directory.
export const share_point_directory_list = data => api.get(url.share_point_directory_list,data)

// Save Share point files to knowledge .
export const share_point_file_save= data => api.upload_file(url.update_combine_bot,data)


// Plans. 

export const fetch_Plans =  data => api.get(url.fetch_plans);


export const start_plan_buying = data => api.get(url.plan_check_out, data)

export const add_payment_methods = data => api.get(url.add_payment_methods)


// Register Method
export const postJwtRegister = (url, data) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = data => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = data => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => api.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => api.get(url.GET_EVENTS);

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = event => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => api.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event => api.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = thread_id => api.get(`${url.GET_MESSAGES}`);

// add Message
export const addMessage = message => api.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = message => api.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = forId => api.delete(url.DELETE_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = product => api.delete(url.DELETE_PRODUCT + '/' + product);

// add Products
export const addNewProduct = product => api.create(url.ADD_NEW_PRODUCT, product);

// update Products
export const updateProduct = product => api.update(url.UPDATE_PRODUCT + '/' + product._id, product);

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = order => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = order => api.update(url.UPDATE_ORDER + '/' + order._id, order);

// delete Order
export const deleteOrder = order => api.delete(url.DELETE_ORDER + '/' + order);

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = customer => api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = customer => api.update(url.UPDATE_CUSTOMER + '/' + customer._id, customer);

// delete Customers
export const deleteCustomer = customer => api.delete(url.DELETE_CUSTOMER + '/' + customer);

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = task => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = task => api.update(url.UPDATE_TASK + '/' + task._id, task);

// delete Task
export const deleteTask = task => api.delete(url.DELETE_TASK + '/' + task);

// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = contact => api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = contact => api.update(url.UPDATE_CONTACT + '/' + contact._id, contact);

// delete Contact
export const deleteContact = contact => api.delete(url.DELETE_CONTACT + '/' + contact);

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = company => api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = company => api.update(url.UPDATE_COMPANIES + '/' + company._id, company);

// delete Companies
export const deleteCompanies = company => api.delete(url.DELETE_COMPANIES + '/' + company);

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = lead => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = lead => api.update(url.UPDATE_LEAD + '/' + lead._id, lead);

// delete Lead
export const deleteLead = lead => api.delete(url.DELETE_LEAD + '/' + lead);

// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = invoice => api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = invoice => api.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = invoice => api.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = ticket => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = ticket => api.update(url.UPDATE_TICKET + '/' + ticket._id, ticket);

// delete Tickets 
export const deleteTicket = ticket => api.delete(url.DELETE_TICKET + '/' + ticket);

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => api.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => api.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => api.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => api.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => api.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => api.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => api.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => api.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => api.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => api.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => api.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => api.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => api.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => api.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => api.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => api.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => api.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => api.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => api.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => api.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => api.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => api.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => api.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => api.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => api.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => api.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => api.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => api.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => api.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => api.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => api.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => api.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => api.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => api.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => api.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => api.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => api.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => api.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => api.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => api.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => api.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => api.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => api.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => api.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => api.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => api.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => api.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project) => api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project) => api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project) => api.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = (team) => api.get(url.GET_TEAMDATA, team);
export const deleteTeamData = (team) => api.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team) => api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team) => api.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = (folder) => api.get(url.GET_FOLDERS, folder);
export const deleteFolder = (folder) => api.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder) => api.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder) => api.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = (file) => api.get(url.GET_FILES, file);
export const deleteFile = (file) => api.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file) => api.create(url.ADD_NEW_FILE, file);
export const updateFile = (file) => api.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = (todo) => api.get(url.GET_TODOS, todo);
export const deleteTodo = (todo) => api.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo) => api.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo) => api.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = (project) => api.get(url.GET_PROJECTS, project);
export const addNewProject = (project) => api.create(url.ADD_NEW_TODO_PROJECT, project);

//Job Application
export const getJobApplicationList = () => api.get(url.GET_APPLICATION_LIST);

//API Key
export const getAPIKey = () => api.get(url.GET_API_KEY);

// Kanban Board
export const getTasks = () => api.get(url.GET_TASKS);
export const addNewTasks = (card) => api.create(url.ADD_TASKS, card)
export const updateTasks = (card) => api.put(url.UPDATE_TASKS, card)
export const deleteTasks = (card) => api.delete(url.DELETE_TASKS, { headers: {card} })